module.exports = __webpack_public_path__ + "static/media/inlinefan_updated.ac00d20b.png";